import { BoxInBox } from '@/assets';
import ButtonAnimation from '@/components/common/ButtonAnimation';
import DownloadPortfolioModal from '@/components/common/Modal';
import Header from '@/layouts/Header';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const SectionHeader = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <section className="container-header">
      <Header />
      <div className="line-container-header">
        <div className="line-column" />
        <div className="line-row" />
        <div className="line-column-active" />
        <div className="line-row-active" />
        <div className="text-flex">
          <span>{t('Blockchain')}</span>
          <span>{t('Web Applications')}</span>
          <span>{t('AI')}</span>
          <span>{t('Mobile')}</span>
        </div>
      </div>
      <div className="title-home-page">
        <div className="title-home-page__left">
          <h1>
            {t('Opening')} <br /> {t('New')} <span>{t('Horizons')}</span> {t('for Business')}
          </h1>
          <div className="desc">
            <span>{t('with')}</span>
            <div className="box-image">
              <img src={BoxInBox} alt="box-in-box" width={120} height={122} />
            </div>
            <span>{t('Innovative')}</span>
            <span>{t('Technology Solutions')}</span>
          </div>
        </div>
        <div className="title-home-page__right">
          <div className="title-home-page__right__desc">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
            >
              <circle cx="4" cy="4" r="4" fill="#7360F2" />
            </svg>
            <span>
              {t(
                'We provide customized solutions across various technology fields from blockchain to AI, mobile, and web applications'
              )}
            </span>
          </div>
          <ButtonAnimation title={t('Download Portfolio')} onClick={() => setIsOpen(true)} />
        </div>
      </div>
      <DownloadPortfolioModal isOpen={isOpen} handleClose={() => setIsOpen(false)} />
    </section>
  );
};

export default React.memo(SectionHeader);
